<template>
  <div>
    <div v-if="visible" class="gx-service-modal" aria-hidden="false" @click.self="toggleService">
      <div
        id="gx-service-dialog"
        class="gx-service-modal__panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="gx-service-dialog-title"
      >
        <div class="gx-service-modal__image">
          <img :src="qrCodeUrl" alt="客服二维码">
        </div>
        <p id="gx-service-dialog-title" class="gx-service-modal__title">扫码添加客服</p>
        <p class="gx-service-modal__tip">（早班客服：9:00 - 18:00&emsp;晚班客服：14:00 - 23:00）</p>
        <p class="gx-service-modal__tip">使用流程：<a href="https://www.kdocs.cn/l/cma0rZ7Hb9pN" target="_blank" class="is-link">https://www.kdocs.cn/l/cma0rZ7Hb9pN</a></p>
<!--        <div>
          早班客服
          工作时间：早上9点-下午6点

          晚班客服
          工作时间：下午2点-晚上11点

          使用流程：https://www.kdocs.cn/l/cma0rZ7Hb9pN
        </div>-->
      </div>
    </div>
    <button
      ref="trigger"
      type="button"
      class="gx-service-btn"
      title="客服咨询"
      aria-controls="gx-service-dialog"
      :aria-expanded="String(visible)"
      :style="btnLeft !== null ? { left: btnLeft + 'px', top: btnTop + 'px' } : {}"
      @pointerdown="handleDragStart"
      @click="handleBtnClick"
    >
      💬
    </button>
  </div>
</template>

<script>
import {getKefu} from "@/api/main";

export default {
  name: "FloatingQrCode",
  data() {
    return {
      visible: false,
      originalBodyOverflow: '',
      qrCodeUrl: require('@/assets/images/code611.png'),
      btnLeft: null,
      btnTop: null,
      isDragging: false,
      hasMoved: false,
      dragOffsetX: 0,
      dragOffsetY: 0,
      dragStartX: 0,
      dragStartY: 0
    };
  },
  mounted() {
    this.fetchKefuCode()
    window.addEventListener('keydown', this.handleKeydown)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeydown)
    window.removeEventListener('pointermove', this.handleDragMove)
    window.removeEventListener('pointerup', this.handleDragEnd)
    this.setPageScrollLocked(false)
  },
  methods: {
    fetchKefuCode() {
      getKefu().then(res => {
        if (res.code === 200 && res.data && res.data.value) {
          this.qrCodeUrl = res.data.value;
        }
      }).catch(() => {})
    },
    handleDragStart(e) {
      // 仅响应主键（鼠标左键 / 触摸 / 笔）
      if (e.button !== undefined && e.button !== 0) return
      this.isDragging = true
      this.hasMoved = false
      const rect = this.$refs.trigger.getBoundingClientRect()
      // 首次拖拽时，将 CSS 的 right/bottom 定位切换为 left/top，坐标取当前实际位置
      if (this.btnLeft === null) {
        this.btnLeft = rect.left
        this.btnTop = rect.top
      }
      this.dragOffsetX = e.clientX - rect.left
      this.dragOffsetY = e.clientY - rect.top
      this.dragStartX = e.clientX
      this.dragStartY = e.clientY
      try {
        this.$refs.trigger.setPointerCapture(e.pointerId)
      } catch (err) {}
      window.addEventListener('pointermove', this.handleDragMove)
      window.addEventListener('pointerup', this.handleDragEnd)
      document.body.style.userSelect = 'none'
    },
    handleDragMove(e) {
      if (!this.isDragging) return
      const dx = e.clientX - this.dragStartX
      const dy = e.clientY - this.dragStartY
      if (Math.abs(dx) > 3 || Math.abs(dy) > 3) {
        this.hasMoved = true
      }
      const btn = this.$refs.trigger
      const maxLeft = window.innerWidth - btn.offsetWidth
      const maxTop = window.innerHeight - btn.offsetHeight
      let left = e.clientX - this.dragOffsetX
      let top = e.clientY - this.dragOffsetY
      left = Math.max(0, Math.min(left, maxLeft))
      top = Math.max(0, Math.min(top, maxTop))
      this.btnLeft = left
      this.btnTop = top
    },
    handleDragEnd() {
      if (!this.isDragging) return
      this.isDragging = false
      window.removeEventListener('pointermove', this.handleDragMove)
      window.removeEventListener('pointerup', this.handleDragEnd)
      document.body.style.userSelect = ''
    },
    handleBtnClick() {
      // 拖拽后不触发点击切换
      if (this.hasMoved) {
        this.hasMoved = false
        return
      }
      this.toggleService()
    },
    toggleService() {
      this.visible = !this.visible
      this.setPageScrollLocked(this.visible)
      if (!this.visible) {
        this.$nextTick(() => this.$refs.trigger.focus())
      }
    },
    handleKeydown(event) {
      if (event.key === 'Escape' && this.visible) {
        this.toggleService()
      }
    },
    setPageScrollLocked(locked) {
      if (locked) {
        this.originalBodyOverflow = document.body.style.overflow
        document.body.style.overflow = 'hidden'
        return
      }

      document.body.style.overflow = this.originalBodyOverflow
    }
  }

};
</script>

<style scoped>
.gx-service-modal {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  box-sizing: border-box;
  background: rgba(4, 12, 32, 0.68);
  backdrop-filter: blur(4px);
}

.gx-service-modal__panel {
  width: min(300px, 100%);
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.28);
  padding: 20px 10px;
  box-sizing: border-box;
  text-align: center;
  animation: gx-service-modal-enter 0.24s ease-out;
}

.gx-service-modal__image {
  width: 100%;
}

.gx-service-modal__image img {
  width: 100%;
  aspect-ratio: 1 / 1;
  object-fit: contain;
  display: block;
}

.gx-service-modal__title {
  margin: 14px 0 3px;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 14px;
  color: #4a4a6a;
}
.gx-service-modal__tip{
  font-size: 11px;
  color: #999999;
  margin-bottom: 5px;
}
.is-link{
  color: var(--gx-cyan);
  font-size: 12px;
}
.is-link:hover{
  text-decoration: underline;
}

.gx-service-btn {
  position: fixed;
  right: 28px;
  bottom: 28px;
  z-index: 1001;
  width: 50px;
  height: 50px;
  border: 0;
  border-radius: 50%;
  background: linear-gradient(135deg, #D4A946, #F0C44A);
  color: #1d2745;
  cursor: grab;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  box-shadow: 0 4px 22px rgba(212, 169, 70, 0.65);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  user-select: none;
  touch-action: none;
}

.gx-service-btn:active {
  cursor: grabbing;
}

.gx-service-btn:hover,
.gx-service-btn:focus {
  transform: scale(1.12);
  box-shadow: 0 8px 36px rgba(212, 169, 70, 0.85);
  outline: none;
}

.gx-service-btn:focus-visible {
  outline: 2px solid #ffffff;
  outline-offset: 3px;
}

@keyframes gx-service-modal-enter {
  from {
    opacity: 0;
    transform: scale(0.94);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@media (max-width: 480px) {
  .gx-service-modal {
    padding: 16px;
  }

  .gx-service-modal__panel {
    padding: 16px;
  }

  .gx-service-btn {
    right: 16px;
    bottom: 16px;
    width: 46px;
    height: 46px;
  }
}
</style>
